import CardListContext from "@/contexts/CardListContext";
import useCardList from "@/hooks/useCardList";
import ChartModal from "@/tpo/ChartModal";
import Stack from "@/tpo/Stack";

import ModelContent from "./ModelContent";
import NonGenesBiomarkers from "./NonGenesBiomarkers";

function NonGenesTestContent({ showFullExplanation, userTest, clientId }) {
  const { cardOpen, viewCard, setCardOpen } = useCardList();

  return (
    <Stack gap={[20, 20, 40]}>
      <CardListContext.Provider
        value={{
          viewCard
        }}
      >
        <NonGenesBiomarkers
          userTest={userTest}
          showFullExplanation={showFullExplanation}
          clientId={clientId}
        />
      </CardListContext.Provider>
      <ChartModal close={() => setCardOpen(undefined)} show={!!cardOpen?.type}>
        <ModelContent type={cardOpen?.type} item={cardOpen?.item} />
      </ChartModal>
    </Stack>
  );
}

NonGenesTestContent.defaultProps = {
  showFullExplanation: true
};

export default NonGenesTestContent;
